module.exports = __webpack_public_path__ + "img/nav.b87cb3b0.png";